module.exports = __webpack_public_path__ + "img/e5.b299e6f5.png";